import Box from '@passkeys/ui/box';
import FramedIcon from '@passkeys/ui/framed-icon';
import Text from '@passkeys/ui/text';

import Link from '@/ui/components/link';
import Subpage from '@/ui/components/subpage';

const routes = [
  { path: '/my-passkey/tokens', label: 'Tokens', icon: 'circle-arc-left' },
  { path: '/my-passkey/history', label: 'History', icon: 'clock' },
  { path: '/my-passkey/settings', label: 'Settings', icon: 'hex-nut-large' },
] as const;

function MyPasskeyPage() {
  return (
    <Subpage
      title="My Passkey"
      className="grid w-full auto-rows-min grid-cols-2 gap-2 pb-8"
    >
      {routes.map(({ path, label, icon }) => (
        <Link
          key={path}
          to={path}
          className="transition-opacity hover:opacity-50"
        >
          <Box className="flex flex-col items-start gap-y-6 p-4">
            <FramedIcon
              className="text-black theme-dark:text-white"
              name={icon}
              size={40}
            />
            <Text size={14}>{label}</Text>
          </Box>
        </Link>
      ))}
    </Subpage>
  );
}

export default MyPasskeyPage;
